/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var AttachFileOutlineIcon = function AttachFileOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1579 3.94747C8.93704 3.94747 7.94735 4.93716 7.94735 6.158V16.658C7.94735 18.5329 9.46723 20.0527 11.3421 20.0527C13.653 20.0527 15.5263 18.1794 15.5263 15.8685V7.15395H17.421V15.8685C17.421 19.2258 14.6994 21.9475 11.3421 21.9475C8.42079 21.9475 6.05261 19.5793 6.05261 16.658V6.158C6.05261 3.89072 7.8906 2.05273 10.1579 2.05273C12.4251 2.05273 14.2631 3.89072 14.2631 6.158V15.2673C14.2631 16.6626 13.1321 17.7936 11.7368 17.7936C10.3416 17.7936 9.21051 16.6626 9.21051 15.2673V7.15395H11.1052V15.2673C11.1052 15.6161 11.388 15.8989 11.7368 15.8989C12.0856 15.8989 12.3684 15.6161 12.3684 15.2673V6.158C12.3684 4.93716 11.3787 3.94747 10.1579 3.94747Z"
  }));
};
export default AttachFileOutlineIcon;